import { useState } from "react";

/**
 * Brand logo for NV SKYNET GOA. Renders /brand-logo.png with a light chip so the
 * white-background PNG sits well on dark surfaces. Falls back to a purple monogram.
 */
export default function BrandLogo({ height = 40, className = "" }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`rounded-lg flex items-center justify-center font-display font-extrabold text-white shadow-lg shadow-purple-500/40 bg-gradient-to-br from-purple-500 via-fuchsia-500 to-purple-400 ${className}`}
        style={{ height, width: height, fontSize: height * 0.4 }}
      >
        NV
      </div>
    );
  }

  return (
    <div
      className={`inline-flex items-center rounded-lg bg-white/95 ring-1 ring-purple-500/30 shadow-md shadow-purple-500/20 ${className}`}
      style={{ height, padding: `${Math.max(2, height * 0.08)}px ${Math.max(6, height * 0.18)}px` }}
    >
      <img
        src="/brand-logo.png"
        alt="NV Skynet Goa"
        onError={() => setFailed(true)}
        className="object-contain"
        style={{ height: "100%" }}
      />
    </div>
  );
}
